import config from '../../config';
import ThemedIcon from '../../components/common/ThemedIcon';

import styled from 'styled-components';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';

import Lottie from 'react-lottie';
import { FaPlus } from 'react-icons/fa';

import arrowRight from '../../images/common/arrow-right-black.svg';
import crossIcon from '../../images/common/cross.svg';
import successLottie from '../../images/common/success(4).json';
import loader from '../../images/common/loader.svg';
import { changeProvider, fetchProviders } from '../../services/switch-benefit';

const ModalBoundary = styled.div`
  width: 100vw;
  max-width: 440px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px -4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  position: absolute;
  bottom: 0;
  padding: 24px;
  padding-top: 0;
`;

const Title = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  color: #131836;
  padding-top: 16px;
  padding-bottom: 16px;
`;

const Title2 = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 24px;
  padding-top: 16px;
  padding-bottom: 16px;
`;

const InnerBoundary = styled.div`
  width: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Button1 = styled.button`
  width: 90%;
  padding: 13px;
  background-color: #7651da;
  color: #ffffff;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
`;

const Button2 = styled.button`
  width: 90%;
  padding: 10px;
  background-color: #ffffff;
  border: 1px solid #7651da;
  color: #0f0b28;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
`;

const Button3 = styled.button`
  width: 42px;
  height: 42px;
  padding: 13px;
  background-color: #7651da;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
`;

const Tag1 = styled.p`
  font-family: , sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  text-align: center;
  color: #263069;
`;

const Tag2 = styled.p`
  height: 16px;
  left: 14.67%;
  right: 14.93%;
  top: calc(50% - 16px / 2 + 110px);
  font-family: , sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: flex-end;
  text-align: center;
  color: #263069;
  margin-bottom: 10px;
`;

const BenefitContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  padding-bottom: 16px;
  padding-top: 16px;
`;

const Line = styled.div`
  width: 100%;
  border-bottom: 1px solid #d1c6ff4d;
`;

const Active = styled.div`
  font-family: , sans-serif;
  font-weight: 600;
  font-size: 10px;
  width: 49px;
  border-radius: 8px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  padding-left: 8px;
  padding-right: 8px;
  background-color: #1eb865;
  color: white;
  position: absolute;
  top: 0;
  right: 16px;
`;

const Or = styled.div`
  font-family: , sans-serif;
  font-style: normal;
  position: absolute;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  background: #ffffff;
  padding: 6px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #263069;
`;

const PolicyPickerModal = ({ title, title2, history, entityId, onSwitch }) => {
  const authToken = useSelector((state) => state.user.authToken);
  const dispatch = useDispatch();

  const [benefitProviders, setBenefitProviders] = useState([]);
  const [successfullSwitch, setSuccessfullSwitch] = useState(false);
  const [switchedToLogo, setSwitchedToLogo] = useState('');
  const [loading, setLoading] = useState(false);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: successLottie,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const handleProviderChange = async (id, logo) => {
    try {
      const response = await changeProvider(authToken, id);
      if (response.data.status === 'success') {
        dispatch({
          type: 'RESET_USER',
          authToken: authToken,
        });
        setSuccessfullSwitch(true);
        setSwitchedToLogo(logo);
        setTimeout(
          () =>
            dispatch({
              type: 'SET_SHOW_SWITCH_BENEFIT_MODAL',
              payload: false,
            }),
          3000
        );
      }
    } catch (error) {
      console.error('Error changing provider:', error);
    }
  };

  const addNewBenefit = () => {
    history.push('/link-new-benefit?isSignUp=false');
  };

  const fetchBenefitProviders = async () => {
    try {
      setLoading(true);
      const response = await fetchProviders(authToken);
      setBenefitProviders(response.data.usersOrgs);
    } catch (error) {
      console.error('Error fetching benefit providers:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBenefitProviders();
  }, []);

  return (
    <ModalBoundary>
      {successfullSwitch ? (
        <div className="flex flex-col w-full items-center">
          <Title2 className="text-primary text-center">
            Successfully switched to
          </Title2>
          <img src={switchedToLogo} alt={'new-benefit-logo'} width={154} />
          <Lottie
            options={defaultOptions}
            speed={0.8}
            width={244}
            height={244}
          />
        </div>
      ) : (
        <>
          <div className="flex justify-between">
            <Title>{title}</Title>
            <img
              onClick={() =>
                dispatch({
                  type: 'SET_SHOW_SWITCH_BENEFIT_MODAL',
                  payload: false,
                })
              }
              src={crossIcon}
              alt="close"
              width={12}
            />
          </div>
          <Line />
          <BenefitContainer>
            {loading ? (
              <ThemedIcon src={loader} alt="Loading..." />
            ) : benefitProviders.length === 0 ? (
              <p className="text-accent2-shades5 font-bold py-6">
                No account found
              </p>
            ) : (
              benefitProviders.map((provider) => (
                <div
                  key={provider.dopeEntityId}
                  className={`w-full flex justify-between items-center p-6 border 
                  ${
                    entityId === provider.dopeEntityId
                      ? 'border-primary'
                      : 'border-secondary-shades10 cursor-pointer '
                  } 
                  rounded-xl relative`}
                  onClick={() => {
                    if (entityId === provider.dopeEntityId) return;
                    console.log('Provider clicked', provider);
                    handleProviderChange(
                      provider.dopeEntityId,
                      provider.dopeEntityLogo
                    );
                    onSwitch();
                  }}
                >
                  <div className="flex gap-4 items-center">
                    {provider.dopeEntityLogo && (
                      <img
                        src={provider.dopeEntityLogo}
                        alt={provider.dopeEntityName + '-logo'}
                        width={48}
                      />
                    )}
                    <Tag1>{provider.dopeEntityName}</Tag1>
                  </div>
                  <div>
                    <img src={arrowRight} alt="select" width={6} />
                  </div>
                  {entityId === provider.dopeEntityId && (
                    <Active>Active</Active>
                  )}
                </div>
              ))
            )}
          </BenefitContainer>
          <Line />
          <Title>{title2}</Title>
          <div className="flex w-full justify-between items-center p-4 bg-secondary-shades10 rounded-xl">
            <Tag1>Link Corporate Benefits and Policies</Tag1>
            <Button3 className="rounded-full" onClick={addNewBenefit}>
              <FaPlus />
            </Button3>
          </div>
        </>
      )}
    </ModalBoundary>
  );
};

export default PolicyPickerModal;
